// Only one song snippet should play at a time across the whole ranking
// table - every FallbackTrackPlayer (upload/Deezer/YouTube via
// /api/artist-top-track) instance shares this module-level singleton
// rather than each managing playback in
// isolation. `id` is a stable per-component-instance token (a ref, not a
// fresh closure each render) so a player doesn't stop itself when it claims
// playback again (e.g. resuming after a seek).
let _activePlayer = null; // { id, stop }

export function claimExclusivePlayback(id, stop) {
  if (_activePlayer && _activePlayer.id !== id) {
    _activePlayer.stop();
  }
  _activePlayer = { id, stop };
}

export function releaseExclusivePlayback(id) {
  if (_activePlayer && _activePlayer.id === id) {
    _activePlayer = null;
  }
}

// Unconditional stop, for events where nothing is "claiming" playback but
// whatever's currently playing should stop anyway - e.g. sorting the table,
// which can move the playing row far from where it visually was, so a fan
// could lose track of what's playing and start a second snippet without
// realizing the first was still going.
export function stopExclusivePlayback() {
  if (_activePlayer) {
    _activePlayer.stop();
    _activePlayer = null;
  }
}
